import React from 'react';
var RightChevron = function (_a) {
    var _b = _a.height, height = _b === void 0 ? 100 : _b, _c = _a.width, width = _c === void 0 ? 100 : _c, _d = _a.stroke, stroke = _d === void 0 ? '#ffffff' : _d, _e = _a.strokeWidth, strokeWidth = _e === void 0 ? 1 : _e;
    return (React.createElement("svg", { width: width, height: height, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M10 16L14 12L10 8", stroke: stroke, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" })));
};
export default RightChevron;
